import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { ClienteAnaliseFinanceira } from '../cliente-analise-financeira';

@Injectable({
    providedIn: 'root'
})
export class ClienteAnaliseFinanceiraHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/clienteanalisefinanceira`;
    }

    /** Carrega a análise financeira do cliente informado */
    load(idCliente: number): Observable<ClienteAnaliseFinanceira> {
        return this.customHttp.get<ClienteAnaliseFinanceira>(`${this.pathApi}/${idCliente}`);
    }
}
